<script>
	import {API, http_headers} from '../global.js'
	import {onMount} from 'svelte'
	import {createEventDispatcher} from 'svelte'
	const dispatch = createEventDispatcher()
	let hoy = new Date()
	let aYear = hoy.getFullYear()
	let hotel = 1
	
	let loading=false
	let dow = ['','Do','Lu','Ma','Mi','Ju','Vi','Sa']
	/*
	let cant_semanas=''
	let productos = []
	let producto = 1

	let tipos_semana = []
	let temporadas_arr = ['PUN','PLA','ORO','ROY','CLA']
	*/
	const close = () =>	dispatch('close')

	let _complejos = ['','RDA','RDE']
	let _capacidades = ['3PAX','4PAX','6PAX','8PAX','2PAX(*)','4PAX(*)','2PAX(*)']
	let _fecha = `${hoy.getFullYear()}-${hoy.getMonth()+1}-${hoy.getDate()}` //.toLocaleString() //'05-07-2022'
	let _idcomplejo = 1
	let _idcapacidad = 0
	let _acumulado = 0
	let _marcados = []
	let _idmarcados = ''
	let update=false
	let cant_dias_marcados = 0

	$: make_table = async () => {
		//if(!_idcomplejo || !_idcapacidad || !_fecha) return []
		_marcados = []
		_idmarcados = ''
		cant_dias_marcados = 0
		_acumulado = 0
		let query = `select top 15 pd.IdPuntosDia,pd.IdComplejo,pd.IdCapacidad,convert(varchar(10),pd.Fecha,105) Fecha,pd.Puntos,
						case when not f.IdFeriado is null then 1 else 0 end Feriado,
						DATEPART ( dw , pd.Fecha ) dow
					from PuntosDia pd
					left join Feriados f on f.Fecha = pd.Fecha and f.Activo =1
					where pd.Fecha>='${_fecha}' and pd.Activo =1
					and pd.IdComplejo =${_idcomplejo} and pd.IdCapacidad = ${_idcapacidad}`

		let rs = await fetch(`${API}/exec-query?u=${update}`,
			{
				method:'POST',
				headers: http_headers,
				body:JSON.stringify({query})	
			})
		let ds = await rs.json()
		if(ds.success) return ds.data
		else throw new Error(ds)
		
	}


	function marcar(pd){
		let borrar = -1
		_marcados.map( (itm,idx) => itm.IdPuntosDia == pd.IdPuntosDia ? borrar=idx : borrar=borrar)
		if(borrar!=-1){	
			_marcados.splice(borrar,1)
		}else{
			_marcados.push(pd)
		}
		_idmarcados = _marcados.map(itm=>itm.IdPuntosDia)
		_idmarcados = _idmarcados.toString()
		_acumulado = _marcados.reduce( (acu,itm) => acu+itm.Puntos, 0)
		cant_dias_marcados = _marcados.length
		//console.log(_idmarcados)
	}
/*
	async function getTiposSemana(p,h){
		loading = true
		let rs = await fetch(`${API}/tipos-semana/${h}/${p}`)
		let ds = await rs.json()
		loading = false
		tipos_semana = ds.data || []
	}

	onMount( async() => {
		return
		let rs = await fetch(`${API}/get-all/productos`)
		let ds = await rs.json()
		productos = ds.data || []
	})
	*/
</script>

<div class="offcanvas offcanvas-end show" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel" style="visibility: visible;">
  <div class="offcanvas-header">
    
	<div class="row">
		<div class="col">
			
			<input class="text-center" type='date' bind:value={_fecha} />
			<select bind:value={_idcomplejo}>
				{#each _complejos as co, index}
					<option value="{index}">{co}</option>
				{/each}
			</select>
			<select bind:value={_idcapacidad}>
				{#each _capacidades as ca, index}
					<option value="{index}">{ca}</option>
				{/each}
			</select>
			
		</div>
	</div>
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close" on:click="{close}"></button>
  </div>
  
  <div class="offcanvas-body">

  	{#await make_table()}
			<p>Loading....</p>
		{:then rs}
			<table class="table table-sm">
				<tbody>
					{#each rs as pundia, index}
						<tr class="{pundia.Feriado?'bg-warning':''}">
							<td><i class="{pundia.dow==7?'text-success':'text-secondary'}">({dow[pundia.dow]})</i>   {pundia.Fecha}</td>
							<td class="text-end {_idmarcados.indexOf(pundia.IdPuntosDia.toString())!=-1?'text-primary':''}" on:click={marcar(pundia)}>
								{pundia.Puntos} Pts
							</td>
						</tr>

					{/each}
				</tbody>
			</table>
			<p class="text-end">({cant_dias_marcados} días) {_acumulado} Pts</p>
			

	{/await}
  </div>
</div>